<template>
  <div class="main-wrapper">
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Header -->
        <div class="page-header">
          <div class="row">
            <div class="col-sm-12 d-flex align-items-center justify-content-between">
              <div>
                <h3 class="page-title mb-1">My Article Dashboard</h3>
                <ul class="breadcrumb mb-0">
                  <li class="breadcrumb-item active">For current user</li>
                </ul>
              </div>
              <div class="btn-group">
                <button class="btn btn-white" :class="{'btn-primary text-white': days===7}"  @click="changeDays(7)">7d</button>
                <button class="btn btn-white" :class="{'btn-primary text-white': days===30}" @click="changeDays(30)">30d</button>
                <button class="btn btn-white" :class="{'btn-primary text-white': days===90}" @click="changeDays(90)">90d</button>
              </div>
            </div>
          </div>
        </div>

        <!-- KPIs -->
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6" v-for="k in kpiList" :key="k.label">
            <div class="card dash-widget soft-card">
              <div class="card-body">
                <span class="dash-widget-icon"><i :class="k.icon"></i></span>
                <div class="dash-widget-info">
                  <h3>{{ k.value }}</h3>
                  <span>{{ k.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick step chips -->
        <div class="card border-0 shadow-sm mb-3">
          <div class="card-body py-3">
            <div class="d-flex align-items-center flex-wrap">
              <span class="mr-3 text-muted small">My by step:</span>
              <div
                v-for="s in stepMetaList"
                :key="s.key"
                class="chip-step mr-2 mb-2"
                :class="s.badgeClass"
                :title="s.label"
              >
                <i :class="['la', s.icon, 'mr-1']"></i>
                {{ s.short }}: <strong class="ml-1">{{ myByStep(s.key) }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- Charts -->
        <div class="row">
          <div class="col-md-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <h5 class="card-title mb-0">My Articles by Step</h5>
                  <span class="badge badge-soft-primary">{{ days }} days</span>
                </div>
                <div id="bar-my-step" style="height: 280px;"></div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <h5 class="card-title mb-0">My Progress (Share by Step)</h5>
                  <span class="badge badge-soft-secondary">{{ days }} days</span>
                </div>
                <div id="donut-my-step" style="height: 280px;"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data blocks -->
        <div class="row">
          <!-- WIP -->
          <div class="col-lg-6 d-flex">
            <div class="card card-table flex-fill border-0 shadow-sm">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">My Work-in-Progress</h5>
                <span class="badge badge-soft-warning">{{ wipTotal }}</span>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th style="min-width:230px">Title / Keyword</th>
                        <th>Step</th>
                        <th>Site</th>
                        <th class="text-right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="a in wipRows" :key="a.id">
                        <td>
                          <div class="font-weight-600 text-truncate maxw-240" :title="a.title || ('#'+a.id)">
                            {{ a.title || ('#' + a.id) }}
                          </div>
                          <div class="small text-muted">
                            <span v-if="a.mainKeyword">KW: {{ a.mainKeyword }}</span>
                            <span v-else>KW: —</span>
                          </div>
                        </td>
                        <td>
                          <span class="badge" :class="badgeFor(a.step)">
                            <i :class="['la', iconFor(a.step), 'mr-1']"></i>{{ shortStep(a.step) }}
                          </span>
                        </td>
                        <td>{{ siteName(a.selectedSiteId) || '-' }}</td>
                        <td class="text-right">
                          <button
                            class="btn btn-sm btn-outline-primary btn-rounded"
                            @click="continueWriting(a)"
                            :disabled="a.step === 'PUSHED'"
                            :title="a.step==='PUSHED' ? 'Đã đăng, không viết tiếp' : 'Viết tiếp đúng bước hiện tại'"
                          >
                            <i class="la la-pen-nib mr-1"></i> Viết tiếp
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!loading && wipRows.length===0">
                        <td colspan="4" class="text-center text-muted py-3">No item</td>
                      </tr>
                      <tr v-if="loading">
                        <td colspan="4" class="text-center text-muted py-3">
                          <span class="spinner-border spinner-border-sm mr-1"></span> Loading...
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Pagination -->
              <div class="card-footer d-flex align-items-center justify-content-between">
                <div class="small text-muted">
                  Showing <strong>{{ wipFrom }}</strong>–<strong>{{ wipTo }}</strong> of <strong>{{ wipTotal }}</strong>
                </div>
                <div class="d-flex align-items-center">
                  <select class="custom-select custom-select-sm mr-2 w-auto" v-model.number="wipSize" @change="wipChangeSize">
                    <option :value="5">5</option>
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                  </select>
                  <div class="btn-group btn-group-sm" role="group">
                    <button class="btn btn-outline-secondary" :disabled="wipPage===0 || loading" @click="wipPrev">
                      <i class="la la-angle-left"></i>
                    </button>
                    <button class="btn btn-outline-secondary" :disabled="wipPage>=wipTotalPages-1 || loading" @click="wipNext">
                      <i class="la la-angle-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Recent Pushed -->
          <div class="col-lg-6 d-flex">
            <div class="card card-table flex-fill border-0 shadow-sm">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h5 class="card-title mb-0">My Recent (Pushed)</h5>
                <span class="badge badge-soft-success">{{ pushedTotal }}</span>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th style="min-width:230px">Title</th>
                        <th>Site</th>
                        <th class="text-right">Updated</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="r in pushedRows" :key="r.id">
                        <td>
                          <div class="font-weight-600 text-truncate maxw-240" :title="r.title || ('#'+r.id)">
                            {{ r.title || ('#' + r.id) }}
                          </div>
                          <div class="small text-muted" v-if="r.slug">
                            <i class="la la-link mr-1"></i>{{ r.slug }}
                          </div>
                        </td>
                        <td>{{ siteName(r.selectedSiteId) || '-' }}</td>
                        <td class="text-right">{{ fmtDate(r.updatedAt) }}</td>
                      </tr>
                      <tr v-if="!loading && pushedRows.length===0">
                        <td colspan="3" class="text-center text-muted py-3">No recent pushed posts</td>
                      </tr>
                      <tr v-if="loading">
                        <td colspan="3" class="text-center text-muted py-3">
                          <span class="spinner-border spinner-border-sm mr-1"></span> Loading...
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Pagination -->
              <div class="card-footer d-flex align-items-center justify-content-between">
                <div class="small text-muted">
                  Showing <strong>{{ pushedFrom }}</strong>–<strong>{{ pushedTo }}</strong> of <strong>{{ pushedTotal }}</strong>
                </div>
                <div class="d-flex align-items-center">
                  <select class="custom-select custom-select-sm mr-2 w-auto" v-model.number="pushedSize" @change="pushedChangeSize">
                    <option :value="5">5</option>
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                  </select>
                  <div class="btn-group btn-group-sm" role="group">
                    <button class="btn btn-outline-secondary" :disabled="pushedPage===0 || loading" @click="pushedPrev">
                      <i class="la la-angle-left"></i>
                    </button>
                    <button class="btn btn-outline-secondary" :disabled="pushedPage>=pushedTotalPages-1 || loading" @click="pushedNext">
                      <i class="la la-angle-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../api'
export default {
  name: 'UserDashboardView',
  data() {
    return {
      loading: true,
      error: null,
      days: 30,

      // stats
      myStats: { total: 0, byStep: {} },
      kpis: { total: 0, finalized: 0, pushed: 0, inProgress: 0 },

      // lists (ALL items, client-side paginate)
      wipAll: [],
      pushedAll: [],

      // pagination states
      wipPage: 0, wipSize: 10,
      pushedPage: 0, pushedSize: 10,

      // charts
      chartBar: null,
      chartDonut: null,

      // site map
      sites: [],
    }
  },
  computed: {
    kpiList() {
      return [
        { label: `My Articles (${this.days}d)`, value: this.kpis.total, icon: 'la la-file-alt' },
        { label: 'Finalized',                    value: this.kpis.finalized, icon: 'la la-check-circle' },
        { label: 'Pushed to WP',                 value: this.kpis.pushed, icon: 'la la-rocket' },
        { label: 'In Progress',                  value: this.kpis.inProgress, icon: 'la la-hourglass-half' },
      ]
    },
    stepMetaList() {
      return [
        { key:'INIT',              short:'Init',       label:'Init',            icon:'la-flag',             badgeClass:'badge-soft-secondary' },
        { key:'SUB_KEYWORDS',      short:'SubKW',      label:'Sub Keywords',    icon:'la-list-ul',          badgeClass:'badge-soft-info' },
        { key:'OUTLINE',           short:'Outline',    label:'Outline',         icon:'la-sitemap',          badgeClass:'badge-soft-warning' },
        { key:'TITLE_DESCRIPTION', short:'Title/Desc', label:'Title + Desc',    icon:'la-heading',          badgeClass:'badge-soft-primary' },
        { key:'SEMANTIC_KEYWORDS', short:'Semantic',   label:'Semantic KW',     icon:'la-project-diagram',  badgeClass:'badge-soft-dark' },
        { key:'CONTENT',           short:'Content',    label:'Content',         icon:'la-file-alt',         badgeClass:'badge-soft-success' },
        { key:'FINALIZED',         short:'Final',      label:'Finalized',       icon:'la-check-circle',     badgeClass:'badge-soft-success' },
        { key:'PUSHED',            short:'Pushed',     label:'Pushed',          icon:'la-rocket',           badgeClass:'badge-soft-success' },
      ]
    },

    /* ------ WIP pagination computed ------ */
    wipTotal() { return this.wipAll.length },
    wipTotalPages() { return Math.max(1, Math.ceil(this.wipTotal / this.wipSize)) },
    wipRows() {
      const start = this.wipPage * this.wipSize
      return this.wipAll.slice(start, start + this.wipSize)
    },
    wipFrom() { return this.wipTotal === 0 ? 0 : (this.wipPage * this.wipSize) + 1 },
    wipTo() { return Math.min((this.wipPage + 1) * this.wipSize, this.wipTotal) },

    /* ------ Pushed pagination computed ------ */
    pushedTotal() { return this.pushedAll.length },
    pushedTotalPages() { return Math.max(1, Math.ceil(this.pushedTotal / this.pushedSize)) },
    pushedRows() {
      const start = this.pushedPage * this.pushedSize
      return this.pushedAll.slice(start, start + this.pushedSize)
    },
    pushedFrom() { return this.pushedTotal === 0 ? 0 : (this.pushedPage * this.pushedSize) + 1 },
    pushedTo() { return Math.min((this.pushedPage + 1) * this.pushedSize, this.pushedTotal) },
  },
  mounted() {
    this.initThemeHelpers()
    this.fetchSites().then(() => this.reload())
  },
  beforeUnmount() {
    if (this.chartBar && this.chartBar.el) this.chartBar.el.empty()
    if (this.chartDonut && this.chartDonut.el) this.chartDonut.el.empty()
  },
  methods: {
    /* ---------- Loaders ---------- */
    async reload() {
      await this.fetchMyStats()
      await this.fetchRecentMine()
    },
    changeDays(n) { this.days = n; this.reload() },

    async fetchSites() {
      try {
        const { data } = await axios.get('/api/wp-sites', { params: { page: 0, size: 200 } })
        this.sites = data?.content || []
      } catch { this.sites = [] }
    },
    siteName(id) {
      const found = (this.sites || []).find(s => String(s.id) === String(id))
      return found ? found.name : null
    },

    async fetchMyStats() {
      try {
        this.loading = true; this.error = null
        const token = localStorage.getItem('token')
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const params = { days: this.days }
        const { data } = await axios.get('/api/articles/stats/my', { params, headers })
        this.myStats = data || { total: 0, byStep: {} }
        this.computeKPIs()
        this.drawBar(); this.drawDonut()
      } catch (e) {
        this.error = e?.response?.status === 401 ? 'Bạn chưa đăng nhập hoặc token hết hạn.' : 'Không tải được thống kê.'
      } finally { this.loading = false }
    },

    async fetchRecentMine() {
      try {
        // Lấy nhiều 1 chút rồi phân trang client-side
        const { data } = await axios.get('/api/articles/stats/recent/my', { params: { limit: 300 } })
        const list = Array.isArray(data) ? data : []
        this.wipAll = list.filter(x => x.step !== 'PUSHED')
        this.pushedAll = list.filter(x => x.step === 'PUSHED')
        // reset page nếu overflow
        if (this.wipPage > this.wipTotalPages - 1) this.wipPage = 0
        if (this.pushedPage > this.pushedTotalPages - 1) this.pushedPage = 0
      } catch {
        this.wipAll = []; this.pushedAll = []
      }
    },

    /* ---------- KPIs & helpers ---------- */
    computeKPIs() {
      const byStep = this.myStats.byStep || {}
      const total = Number(this.myStats.total || 0)
      const finalized = Number(byStep.FINALIZED || 0)
      const pushed = Number(byStep.PUSHED || 0)
      const inProgress = Math.max(0, total - finalized - pushed)
      this.kpis = { total, finalized, pushed, inProgress }
    },
    myByStep(key) {
      const v = this.myStats?.byStep?.[key]
      return typeof v === 'number' ? v : (v ? Number(v) : 0)
    },
    shortStep(s) {
      const m = this.stepMetaList.find(x => x.key === s); return m ? m.short : 'Init'
    },
    iconFor(s) {
      const m = this.stepMetaList.find(x => x.key === s); return m ? m.icon : 'la-flag'
    },
    badgeFor(s) {
      switch (s) {
        case 'INIT': return 'badge-soft-secondary'
        case 'SUB_KEYWORDS': return 'badge-soft-info'
        case 'OUTLINE': return 'badge-soft-warning'
        case 'TITLE_DESCRIPTION': return 'badge-soft-primary'
        case 'SEMANTIC_KEYWORDS': return 'badge-soft-dark'
        case 'CONTENT': return 'badge-soft-success'
        case 'FINALIZED': return 'badge-soft-success'
        case 'PUSHED': return 'badge-soft-success'
        default: return 'badge-soft-secondary'
      }
    },
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(iso)
      const pad = n => n < 10 ? '0'+n : n
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },

    /* ---------- Navigate ---------- */
    continueWriting(row) {
      if (row.step === 'PUSHED') return
      const map = {
        INIT: 1, SUB_KEYWORDS: 2, OUTLINE: 3, TITLE_DESCRIPTION: 4,
        SEMANTIC_KEYWORDS: 5, CONTENT: 6, FINALIZED: 6, PUSHED: 6,
      }
      const wizardStep = map[row.step] || 1
      this.$router.push({ path: `/ai-writer/${row.id}`, query: { step: String(wizardStep) } })
    },

    /* ---------- Charts ---------- */
    drawBar() {
      const byStep = this.myStats.byStep || {}
      const order = ['INIT','SUB_KEYWORDS','OUTLINE','TITLE_DESCRIPTION','SEMANTIC_KEYWORDS','CONTENT','FINALIZED','PUSHED']
      const data = order.map(k => ({ y: k.replace('_',' '), a: Number(byStep[k] || 0) }))
      if (!window.Morris) return
      if (!this.chartBar) {
        this.chartBar = window.Morris.Bar({
          element: 'bar-my-step',
          data, xkey: 'y', ykeys: ['a'], labels: ['Count'],
          barColors: ['#3f72ff'], lineWidth: '3px', resize: true, redraw: true
        })
      } else { this.chartBar.setData(data) }
    },
    drawDonut() {
      const byStep = this.myStats.byStep || {}
      const data = Object.keys(byStep).map(k => ({ label: k.replace('_',' '), value: Number(byStep[k] || 0) }))
      if (!window.Morris) return
      if (!this.chartDonut) {
        this.chartDonut = window.Morris.Donut({
          element: 'donut-my-step', data, resize: true,
          colors: ['#3f72ff','#f43b48','#00b894','#fdcb6e','#0984e3','#6c5ce7','#e17055','#2d3436']
        })
      } else { this.chartDonut.setData(data) }
    },

    /* ---------- Pagination handlers ---------- */
    wipChangeSize() { this.wipPage = 0 },
    wipPrev() { if (this.wipPage > 0) this.wipPage-- },
    wipNext() { if (this.wipPage < this.wipTotalPages - 1) this.wipPage++ },

    pushedChangeSize() { this.pushedPage = 0 },
    pushedPrev() { if (this.pushedPage > 0) this.pushedPage-- },
    pushedNext() { if (this.pushedPage < this.pushedTotalPages - 1) this.pushedPage++ },

    /* ---------- Theme helpers ---------- */
    initThemeHelpers() {
      const $pageWrapper = $('.page-wrapper'); const $slimScrolls = $('.slimscroll')
      if($slimScrolls.length > 0) {
        $slimScrolls.slimScroll({ height:'auto', width:'100%', position:'right', size:'7px', color:'#ccc', wheelStep:10, touchScrollStep:100 })
        const wHeight = $(window).height() - 60; $slimScrolls.height(wHeight); $('.sidebar .slimScrollDiv').height(wHeight)
        $(window).resize(function(){ const rHeight = $(window).height() - 60; $slimScrolls.height(rHeight); $('.sidebar .slimScrollDiv').height(rHeight) })
      }
      const pHeight = $(window).height(); $pageWrapper.css('min-height', pHeight)
      $(window).resize(function(){ const prHeight = $(window).height(); $pageWrapper.css('min-height', prHeight) })
    },
  }
}
</script>

<style scoped>
/* Soft badges */
.badge-soft-primary   { background: rgba(0,123,255,.12); color:#007bff; }
.badge-soft-secondary { background: rgba(108,117,125,.12); color:#6c757d; }
.badge-soft-success   { background: rgba(40,167,69,.12); color:#28a745; }
.badge-soft-danger    { background: rgba(220,53,69,.12); color:#dc3545; }
.badge-soft-warning   { background: rgba(255,193,7,.18); color:#856404; }
.badge-soft-info      { background: rgba(23,162,184,.12); color:#17a2b8; }
.badge-soft-dark      { background: rgba(33,37,41,.12); color:#343a40; }

/* Cards */
.soft-card { border: 0; box-shadow: 0 4px 14px rgba(0,0,0,.04); }
.dash-widget .dash-widget-icon { background: rgba(0,0,0,.04); }

/* Chips */
.chip-step {
  border-radius: 50rem;
  padding: .35rem .6rem;
  font-size: .8125rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

/* Tables */
.table td, .table th { vertical-align: middle; }
.maxw-240 { max-width: 240px; }

/* Buttons */
.btn-rounded { border-radius: 50rem; }

/* Morris fix inside cards */
#bar-my-step, #donut-my-step { width: 100%; }
</style>
